// extracted by mini-css-extract-plugin
module.exports = {"eventPageContainer":"event_eventPageContainer__23DeS","body":"event_body__25LPK","spinner":"event_spinner__1fT3w","overlay":"event_overlay__2eIbF"};